var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGallery(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 2.5H5.5C4.83696 2.5 4.20107 2.76339 3.73223 3.23223C3.26339 3.70107 3 4.33696 3 5V15C3 15.663 3.26339 16.2989 3.73223 16.7678C4.20107 17.2366 4.83696 17.5 5.5 17.5H15.5C16.163 17.5 16.7989 17.2366 17.2678 16.7678C17.7366 16.2989 18 15.663 18 15V5C18 4.33696 17.7366 3.70107 17.2678 3.23223C16.7989 2.76339 16.163 2.5 15.5 2.5ZM5.5 4.16667H15.5C15.721 4.16667 15.933 4.25446 16.0893 4.41074C16.2455 4.56702 16.3333 4.77899 16.3333 5V11.9667L13.6667 9.69167C13.2535 9.3517 12.7351 9.16583 12.2 9.16583C11.6649 9.16583 11.1465 9.3517 10.7333 9.69167L4.66667 14.75V5C4.66667 4.77899 4.75446 4.56702 4.91074 4.41074C5.06702 4.25446 5.27899 4.16667 5.5 4.16667V4.16667ZM15.5 15.8333H5.96667L11.8 10.9667C11.9121 10.8835 12.0479 10.8385 12.1875 10.8385C12.3271 10.8385 12.4629 10.8835 12.575 10.9667L16.3333 14.1667V15C16.3333 15.221 16.2455 15.433 16.0893 15.5893C15.933 15.7455 15.721 15.8333 15.5 15.8333Z",
    fill: "#676C77"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.16797 8.33337C7.85832 8.33337 8.41797 7.77373 8.41797 7.08337C8.41797 6.39302 7.85832 5.83337 7.16797 5.83337C6.47761 5.83337 5.91797 6.39302 5.91797 7.08337C5.91797 7.77373 6.47761 8.33337 7.16797 8.33337Z",
    fill: "#676C77"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGallery);
export default __webpack_public_path__ + "static/media/gallery.4e61e1b5086c95411e4796f0b04216a8.svg";
export { ForwardRef as ReactComponent };